import classes from "./ClemMethod.module.scss";
import { ReactComponent as AssetOwner } from "../../../assets/icons/assetOwner.svg";
import { ReactComponent as FinancialInstiution } from "../../../assets/icons/financialInstitution.svg";

type Props = {
  id: string;
  method: string;
  title: React.ReactNode;
  imgUrl: string;
  content: string[];
};

const cards = [
  {
    title: "Asset Owners",
    icon: <AssetOwner className={classes.icon} />,
  },
  {
    title: "Financial Institutions",
    icon: <FinancialInstiution className={classes.icon} />,
  },
];

function ClemMethod(props: Props) {
  const { id, method, title, imgUrl, content } = props;

  return (
    <div className={classes.container} id={id}>
      <div className={classes.method}>CLEM {method}</div>

      <div className={classes.details}>
        <div className={classes.title}>{title}</div>

        <img className={classes.img} src={imgUrl} alt={`CLEM ${method}`} />

        <div className={classes["sub-title"]}>
          {method}: <span>Who we help</span>
        </div>

        <div className={classes["cards-container"]}>
          {cards.map(({ title: cardTitle, icon }, index) => (
            <div className={classes.card} key={cardTitle}>
              {icon}

              <div className={classes["card-content"]}>
                <h3>{cardTitle}</h3>

                <p>{content[index]}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ClemMethod;
